'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../base-component.types';

import styles from './ResourceBody.module.scss';

type ResourceBodyProps = BaseComponentProps & {
  /**
   * Keeps the content clear of the bars instead of letting it pass beneath them, for a
   * resource whose content is read at a glance rather than scrolled through.
   */
  spacious?: boolean;
  children: ReactNode;
};

/**
 * The scrolling region between a resource's bars. It runs the whole height of the
 * resource and makes its own room for them, so content dissolves under a bar on its way
 * out rather than stopping short of one.
 */
function ResourceBody({
  style,
  className,
  spacious = false,
  children,
  testId = 'ui-resource-body',
}: ResourceBodyProps) {
  return (
    <div
      style={style}
      className={classnames(
        styles['main'],
        spacious && styles['main--spacious'],
        className,
      )}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export { ResourceBody };
